module.exports = __webpack_public_path__ + "img/01_L3.5a9938ab.svg";